import React from "react";
import _ from "lodash";

import logo from "assets/images/say-what/saywhat-logo.png";

const AfterCaptionSubmit = ({ cc_countdown, mobile_app, showcase_params }) => {
  const time_label = _.get(showcase_params, "time_label", "Time Remaining:");
  const text_1 = _.get(
    showcase_params,
    "text_1",
    "Take a look at the table top!"
  );
  const submission_text = _.get(
    showcase_params,
    "submission_text",
    "SUBMISSION RECEIVED!"
  );
  const text_2 = _.get(
    showcase_params,
    "text_2",
    "You'll be voting on your favorite soon!"
  );

  return (
    <div className={`sbm-rec ${mobile_app ? "" : "web-cnt"}`}>
      <img src={logo} className="sw-logo" alt="logo" />
      <div className="sbm-content">
        <div className="box">
          <h4 className="txt">{submission_text}</h4>
        </div>
        <p className="look">{text_1}</p>
        <p className="voting">{text_2}</p>
        <p className="time">{time_label}</p>
        <p className="seconds">{cc_countdown} Seconds</p>
      </div>
    </div>
  );
};

export default AfterCaptionSubmit;
